<ng-container *hasPermission="['ORGANIZATION_CONFIG_READ','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Configurazione ente</h2>
        </div>

        <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
                <a class="nav-link" role="button" [class.active]="activeTab === 'report-variables'"
                    (click)="setTab('report-variables')">Variabili report</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" role="button" [class.active]="activeTab === 'judicial-deposits'"
                    (click)="setTab('judicial-deposits')">Depositi giudiziari</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" role="button" [class.active]="activeTab === 'localities'"
                    (click)="setTab('localities')">Località</a>
            </li>
        </ul>

        <app-report-variables *ngIf="activeTab === 'report-variables'"></app-report-variables>
        <app-judicial-deposits *ngIf="activeTab === 'judicial-deposits'"></app-judicial-deposits>
        <app-localities *ngIf="activeTab === 'localities'"></app-localities>
    </div>
</ng-container>
